/** Manual records share the existing Sheets schema without pretending to be Gmail. */
export function isManualSource(messageId: string): boolean { return messageId.startsWith('manual:'); }
